
/* eslint-disable no-unused-vars */
import { Helmet } from "react-helmet-async";
import './App.css';
import Header from './Header';
import Banner from './Banner';
import IntroSection from './IntroSection';
import LimitedByDesign from "./LimitedByDesign";
import Categories from './Categories';
import StillSocialProofBar from './StillSocialProofBar';
import TopPicks from './TopPicks';
import RotatingHeelSection  from './RotatingHeel';
import AboutUs from './AboutUs';
import WhyShush from './WhyShush';
import Testimonials from './Testimonials';
import StillEmailCapture from './StillEmailCapture';
import BlogTravelGrid from "./BlogTravelGrid";
import HomeCollections from './HomeCollections';
import Footer from './Footer';

function App() {
  return (
    <>
    <Helmet>
        {/* PRIMARY SEO */}
        <title>
          STILL India | Workwear Heels & Accessible Luxury Shoes
        </title>

        <meta
          name="description"
          content="Discover STILL — an accessible luxury footwear brand in India. Shop workwear heels, slingbacks, and pumps designed for structure, comfort, and timeless style."
        />

        <link rel="canonical" href="https://www.stillshoes.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="STILL Footwear India" />
        <meta
          property="og:description"
          content="Accessible luxury footwear designed for modern workwear and everyday elegance."
        />
        <meta property="og:url" content="https://www.stillshoes.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.stillshoes.com/banner.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="STILL Footwear India" />
        <meta
          name="twitter:description"
          content="Refined heels designed for workwear, structure, and quiet luxury."
        />
        <meta name="twitter:image" content="https://www.stillshoes.com/og-image.jpg" />

        {/* ORGANIZATION SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",

            "name": "STILL",
            "url": "https://www.stillshoes.com",
            "logo": "https://www.stillshoes.com/logo_icon.png", // IMPORTANT: replace

            "description":
              "STILL is an accessible luxury footwear brand in India focused on refined workwear heels, slingbacks, and pumps designed with structure, comfort, and timeless aesthetics.",

            "foundingCountry": "India",

            "sameAs": [
              "https://www.instagram.com/stillshoes"
            ],

            "brand": {
              "@type": "Brand",
              "name": "STILL",
              "alternateName": "STILL Footwear"
            },

            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "STILL Footwear Collections",
              "itemListElement": [
                {
                  "@type": "OfferCatalog",
                  "name": "Workwear Heels",
                  "url": "https://www.stillshoes.com/work-heels"
                },
                {
                  "@type": "OfferCatalog",
                  "name": "Accessible Luxury Footwear",
                  "url": "https://www.stillshoes.com/accessible-luxury-footwear"
                }
              ]
            }
          })}
        </script>
      </Helmet>

    <Header />
    <Banner />
    <StillSocialProofBar />
    <LimitedByDesign />
    <TopPicks />
    <HomeCollections />
    <WhyShush />
    <IntroSection />
    <Testimonials />
    <StillEmailCapture />
    <AboutUs />
    <BlogTravelGrid />
    <Footer />
    </>
  );
}

export default App;
